import { defineComponent as _defineComponent } from 'vue'
import CcCard from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCard.ts.vue';
import { CardVariableProps } from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCardVariable.ts.vue';
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import { Icons } from '@/views/Automation/CampaignCreatorV2/helpers/icons';
import { Action, CardType } from '@/views/Automation/CampaignCreatorV2/types';
import { PopoverTriggers, Position } from '@sh/types';
import { computed, ref } from 'vue';

interface Icon {
  type: Icons;
  fill?: boolean;
}

interface Props {
  title?: string;
  items: CardVariableProps[];
  icon?: Icon;
  mainAction?: Action;
  actions?: Action[];
  id: string;
}

interface Emits {
  (event: 'actionClick', value: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcWidgetCard.ts',
  props: {
    title: { default: 'Title' },
    items: null,
    icon: { default: () => ({ type: 'speaker' }) },
    mainAction: null,
    actions: null,
    id: null
  },
  emits: ["actionClick"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'actionClick', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title: string, items: CardVariableProps[], icon: Icon, mainAction?: Action, actions?: Action[], id: string };




const opened = ref(false);
const filteredItems = computed(() => (opened.value ? props.items : props.items.slice(0, 6)));

function dispatchEvent(event: string) {
  emits('actionClick', event);
}

return { __sfc: true,props, emits, opened, filteredItems, dispatchEvent, CcCard, CcIcon, CardType, PopoverTriggers, Position }
}

})